import { useState, createContext, useMemo } from 'react'

const BackgroundMusicContext = createContext()

export const BackgroundMusicProvider = ({ children }) => {
  const [isMusicMuted, setIsMusicMuted] = useState(false)
  const [musicError, setMusicError] = useState(false)
  const [isCasting, setIsCasting] = useState(false)
  const [castToken, setCastToken] = useState(null)
  const [castId, setCastId] = useState(null)

  const value = useMemo(
    () => ({
      isMusicMuted,
      setIsMusicMuted,
      musicError,
      setMusicError,
      isCasting,
      setIsCasting,
      castToken,
      setCastToken,
      castId,
      setCastId
    }),
    [
      isMusicMuted,
      setIsMusicMuted,
      musicError,
      setMusicError,
      isCasting,
      setIsCasting,
      castToken,
      setCastToken,
      castId,
      setCastId
    ]
  )

  return (
    <BackgroundMusicContext.Provider value={value}>
      {children}
    </BackgroundMusicContext.Provider>
  )
}

export default BackgroundMusicContext
